export type LpSettlementLegacyVisibilityFlags = {
  enableLpSettlement: boolean;
  enableOtcSettlementWithLpSettlement: boolean;
  enableLpSettlementLegacy?: boolean;
};

/**
 * LP Settlement (Legacy) is visible only when the dedicated flag is on
 * (missing/undefined defaults to false) and the existing companion formula
 * would have shown it. The companion flag cannot resurrect Legacy when
 * EnableLpSettlementLegacy is false.
 */
export function isLpSettlementLegacyVisible(flags: LpSettlementLegacyVisibilityFlags): boolean {
  const enableLpSettlementLegacy = flags.enableLpSettlementLegacy ?? false;
  return enableLpSettlementLegacy && (!flags.enableLpSettlement || flags.enableOtcSettlementWithLpSettlement);
}
